import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse("fga56sda4gf86a1d"); //秘钥
//AES加密
export function aes128Encrypt(pas) {
  var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(pas));
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString();
}

//AES解密
export function aes128Decrypt(hexData) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(hexData);
  let encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  let obj = JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
  return obj;
}
